module.exports = __webpack_public_path__ + "static/img/1.a9b69d8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/3/1.png
// module id = ShIG
// module chunks = 0